import React, { useEffect, useState } from "react"
import { DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faAngleDown } from "@fortawesome/free-solid-svg-icons"
import ContainerMax from "components/shared/ContainerMax"
import ContentMax from "components/shared/ContentMax"
import GalleryGrid from "components/shared/GalleryGrid"
import BlockTitle from "components/shared/BlockTitle"
import FilterBar from "components/shared/FilterBar"
import FilterDropdown from "components/shared/FilterDropdown"

const Galleries = (props) => {
	// const [selectedGallery, setSelectedGallery] = useState("")
	const [filterText, setFilterText] = useState("SELECT (ALL)")
	const [imageState, setImageState] = useState([])

	useEffect(() => {
		setImages("SELECT (ALL)")
	}, [])

	const setImages = (id) => {
		let images = []

		if (id === "SELECT (ALL)") {
			props.block.galleries.forEach(gallery => {
				images.push(gallery.acfGalleries.images)
			})
		} else {
			images = props.block.galleries[id].acfGalleries.images
		}

		images = images.flat()
		setImageState(images)
	}

  const setFilter = (id, text) => {
		setFilterText(text)

		const filter = id !== "" ? id : text
		setImages(filter)
	}

	const { block } = props
	const { galleries } = block

	const DropDown = (props) => {
		return(
			<FilterDropdown {...props}>
				<DropdownToggle caret>
					{filterText}
					<FontAwesomeIcon icon={faAngleDown} />
				</DropdownToggle>
					
				<DropdownMenu>
					{filterText !== "SELECT (ALL)" && 
						<DropdownItem	onClick={() => setFilter("", "SELECT (ALL)")}>
							SELECT (ALL)
						</DropdownItem>
					}
					{galleries && galleries.map((gallery, i) => {
						if (filterText !== gallery.title) {
							return (
								<DropdownItem 
									key={i}
									onClick={() => setFilter(i, gallery.title)}
								>
									{gallery.title}
								</DropdownItem>
							)
						} else return ""
					})}
				</DropdownMenu>
			</FilterDropdown>
		)
	}

	return(
		<ContainerMax className="my-4">
			<ContentMax>
				{block.title && 
					<BlockTitle 
						white={block.background === "colour" ? true : false} 
						outline={block.background === "colour" ? true : false} 
						baseTitle
					>  
						{block.title}
					</BlockTitle>
				}
				{galleries.length > 1 &&
					<>
						{block.background === "white" ? (
							<FilterBar>
								<div className="filter-title">Filter by</div>
								<DropDown />
							</FilterBar>
						) : (
							<DropDown className="pb-4" />
						)}
					</>
				}
				<GalleryGrid images={imageState} displayMore={true} />
			</ContentMax>
		</ContainerMax>
	)
}

export default Galleries